import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProizvodiAkcijaService {
  constructor(private _http: HttpClient) {}

  dohvatiProizvodeNaAkciji(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'proizvod_na_akciji', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_partnere', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPoslovnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_poslovnicepartnera', a)
      .pipe(map((res: any) => res));
  }

  dodajNovuAkciju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'spremanje_akcije', a)
      .pipe(map((res: any) => res));
  }

  urediAkciju(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredivanje_akcije', a)
      .pipe(map((res: any) => res));
  }

  obrisiAkciju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'brisanje_akcije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiTjedne_u_godini(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_tjedne_u_godini', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDatume_za_tjedan(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_datume_za_tjedan', a)
      .pipe(map((res: any) => res));
  }

  dohvatiTjedan_za_datum(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_tjedan_za_datum', a)
      .pipe(map((res: any) => res));
  }

}
